module.exports = __webpack_public_path__ + "media/images/front/premium-096976334f94e5aa9c09ca9714c2b066.png";